import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Paper,
  Button,
  Container,
} from '@mui/material';
import {
  CheckCircleOutlined,
  HomeOutlined,
} from '@mui/icons-material';
import { useAuthStore } from '../stores/useAuthStore';

const SubscriptionSuccessPage: React.FC = () => {
  const navigate = useNavigate();
  const { refreshSubscriptionStatus } = useAuthStore();

  useEffect(() => {
    // Rafraîchir le statut d'abonnement après paiement réussi
    const timer = setTimeout(() => {
      refreshSubscriptionStatus();
    }, 2000);

    return () => clearTimeout(timer);
  }, [refreshSubscriptionStatus]);

  return (
    <Container maxWidth="md" sx={{ mt: 8 }}>
      <Paper
        elevation={6}
        sx={{
          p: { xs: 4, sm: 6 },
          borderRadius: 3,
          textAlign: 'center',
          background: 'linear-gradient(145deg, #ffffff 0%, #F9FAFB 100%)',
          border: '2px solid #10B981',
        }}
      >
        {/* Icône de succès */}
        <Box
          sx={{
            width: 100,
            height: 100,
            borderRadius: '50%',
            bgcolor: '#10B981',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto',
            mb: 3,
          }}
        >
          <CheckCircleOutlined sx={{ fontSize: 60, color: 'white' }} />
        </Box>

        {/* Titre */}
        <Typography
          variant="h3"
          sx={{
            fontWeight: 800,
            color: '#374151',
            mb: 2,
          }}
        >
          Paiement réussi !
        </Typography>

        <Typography
          variant="h6"
          sx={{
            color: '#6B7280',
            mb: 4,
          }}
        >
          Bienvenue dans Sersal Premium
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: '#374151',
            mb: 4,
          }}
        >
          Votre abonnement a été activé avec succès. Vous avez maintenant accès à toutes les fonctionnalités premium pour gérer vos devis, factures et chantiers.
        </Typography>

        {/* Bouton retour */}
        <Button
          variant="contained"
          size="large"
          startIcon={<HomeOutlined />}
          onClick={() => navigate('/dashboard')}
          sx={{
            py: 1.5,
            px: 4,
            fontSize: '1.1rem',
            fontWeight: 700,
            bgcolor: '#10B981',
            color: 'white',
            '&:hover': {
              bgcolor: '#059669',
            },
          }}
        >
          Retour à l'accueil
        </Button>
      </Paper>
    </Container>
  );
};

export default SubscriptionSuccessPage;
